module.exports = __webpack_public_path__ + "static/media/book.df08f4d6.pdf";